import { fetchMeta } from "../../api/Fetchers/fetch.meta";
import { fetchTags } from "../../api/Fetchers/fetch.tags";
import { fetchReadSerials } from "../../api/Fetchers/fetch.readSerials";
import { fetchApi } from "../../api/Fetchers/fetch.api";
import { retrievePLCinfos } from "../../config/plc.alarm.config";
import { setOperationAlarms } from "../../services/slices/amsSlice";
import { setSensorGroups } from "../../services/slices/sensorGroupSlice";
import { setRenamedSensors } from "../../services/slices/renamedSensorsSlice";
import { setTags } from "../../services/slices/tagsSlice";
import { setSensorLimits } from "../../services/slices/sensorLimitsSlice";
import {
  setShipSerials,
  setImportedIcons,
  setEnvSerial,
  setPLCList,
  setAlarmsPlcConfig,
  setAlarmsAcknowledgeEnabled,
  setCanViewSensorsConfig,
  setCanViewPlcConfig,
} from "../../services/slices/appConfig";
import { setSensorMultiplier } from "../../services/slices/sensorMultiplierSlicer";
import { setAllSettings } from "../../services/slices/settingSlice";
import { setIsSetEnabled } from "../../services/slices/permissionSlice";
import { parseJSON, wrapWithSerial } from "./dataHelpers";
import { postApi } from "../../api/Setters/post.api";
import { setOperationPdfs } from "../../services/slices/operationPdfSlice";

export const loadInitialData = async (dispatch) => {
  const shipSerials = await fetchReadSerials();
  dispatch(setShipSerials(shipSerials));

  const [
    rawGroups,
    rawRenamed,
    rawLimits,
    operationPdfs,
    rawMultiplier,
    tags,
    rawAlarms,
    rawIcons,
    envSerial,
    rawSettings,
    isSetEnabled,
    rawPagePerms,
  ] = await Promise.all([
    fetchMeta("sensor_groups"),
    fetchMeta("renamed_sensors"),
    fetchMeta("limits"),
    fetchMeta("operationPdf"),
    fetchMeta("multiplier"),
    fetchTags(shipSerials),
    fetchMeta("alarms"),
    fetchMeta("importedIcons"),
    fetchApi("env/serial/get", "serial", "get"),
    fetchMeta("settings"),
    postApi("users/pin/abstract/status/is_set", { root: false }, "isSet"),
    fetchMeta("page_permissions"),
  ]);

  dispatch(setImportedIcons(parseJSON(rawIcons, [])));
  dispatch(setSensorGroups(wrapWithSerial(parseJSON(rawGroups), shipSerials)));
  dispatch(setRenamedSensors(wrapWithSerial(parseJSON(rawRenamed), shipSerials)));
  dispatch(setSensorLimits(wrapWithSerial(parseJSON(rawLimits), shipSerials)));
  dispatch(setSensorMultiplier(wrapWithSerial(parseJSON(rawMultiplier), shipSerials)));
  dispatch(setTags(tags));
  dispatch(setOperationPdfs(parseJSON(operationPdfs || "[]")));
  dispatch(setOperationAlarms(parseJSON(rawAlarms)));
  dispatch(setEnvSerial(envSerial));
  dispatch(setAllSettings(parseJSON(rawSettings)));

  dispatch(setAlarmsPlcConfig(true));
  dispatch(setAlarmsAcknowledgeEnabled(true));
  dispatch(setIsSetEnabled(isSetEnabled === true));

  const pagePerms = parseJSON(rawPagePerms, {});
  dispatch(setCanViewSensorsConfig(pagePerms?.noSensors !== true));
  dispatch(setCanViewPlcConfig(pagePerms?.noPlc !== true));

  const plcEntries = await Promise.all(
    shipSerials.map(async (ship) => [ship.serial, (await retrievePLCinfos(ship.serial)) || []]),
  );
  const plcListObj = Object.fromEntries(plcEntries);

  const envSerialAlreadyExists = shipSerials.some((ship) => ship.serial === envSerial);

  if (!envSerialAlreadyExists && envSerial) {
    try {
      plcListObj[envSerial] = (await retrievePLCinfos(envSerial)) || [];
    } catch (err) {
      console.error("Failed to fetch PLC infos for envSerial:", envSerial, err);
    }
  }

  dispatch(setPLCList(plcListObj));
};
